import React, { FunctionComponent, FormEvent, createRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useState } from 'react';

import {
  Button,
  Alert,
  Grid,
  TextField,
} from '@mui/material';

import {
  LoadingButton,
} from '@mui/lab'

import {AppDispatch, RootState, store} from '../../store/store';
import {exceededUpdated, reset} from './forgot-password';
import AuthLayout from '../../layouts/AuthLayout/AuthLayout';
import { useTranslation } from 'react-i18next';
import { push } from '@lagunovsky/redux-react-router'

import './ForgotPassword.css';
import useTitle from '../../helpers/use-title';
import useValidator from '../../helpers/hooks/use-validator';

interface Props {
}

const ForgotPassword:FunctionComponent<Props> = () => {

  const { t } = useTranslation( [ 'forgotPassword' ] );
  useTitle( t( 'set-new-password' ) );

  const { t:tCommon } = useTranslation( [ 'common' ]);

  const dispatch = useDispatch<AppDispatch>();

  const loading = useSelector( ( state: RootState ) => state.pages.forgotPassword.loading );

  const exceeded  = useSelector( ( state: RootState ) => state.pages.forgotPassword.exceeded );

  const [notify, setNotify] = useState(false);

  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  const buttonDisableTime: number = 120000;

  const onSubmit = ( event: FormEvent ) => {
    event.preventDefault();

    const target = event.target as HTMLFormElement;
    const data = Object.fromEntries(new FormData(target));

    dispatch( reset(
      ( data.username as string ).trim(),
      ) ).then( ( action ) => {

      const state = store.getState() as RootState;

      if (state.pages.forgotPassword.exceeded)  {
        setIsButtonDisabled(true);
        setTimeout(() => {
          dispatch(exceededUpdated(false));
          setIsButtonDisabled(false);
          } , buttonDisableTime
        );
        return;
      }

      setNotify(true);
      setIsButtonDisabled(true);
      setTimeout(() => {
        setIsButtonDisabled(false);
        setNotify(false);
        } , buttonDisableTime
      );
      // if( action.payload ) {
      //   dispatch( push( '/forgot-password/verify' ) );
      // }
    })
  }

  const usernameRef = createRef<HTMLInputElement>();
  useValidator( [ usernameRef ] )
    .required()
    .noEmpty()
    .isNumberOrEmail()

  const onBack = () => {
    dispatch( push( '/' ) );
  }

  return (
    <AuthLayout language={ true } header={ true }>
      <div className="page page-forgot-password">
        <form onSubmit={ onSubmit }>
          <h2>{ t( 'reset-your-password' ) }</h2>
          <span>{ t( 'please-enter-your-login' ) }</span>
          { notify && (
            <Alert sx={{mt: 2}}>
              { t( 'forgot-password-button-clicked-alert' ) }
            </Alert>
          ) }

          { exceeded && (
            <Alert severity="error" sx={{mt: 2}}>
              { t( 'attempt-limit-exceeded-please-try-after-some-time' ) }
            </Alert>
          ) }

          <Grid container spacing={2}>
            <Grid item xs={12} sx={{ mt: 1 }}>
              <TextField
                autoComplete="username email"
                label={ t( 'enter-your-login-V2' ) }
                inputRef={ usernameRef }
                name="username"
                variant='standard'
                fullWidth
              />
            </Grid>
            <Grid item xs={12}>
              <LoadingButton
                loading={ loading ==='pending' }
                fullWidth
                variant='contained'
                type="submit"
                disabled={ isButtonDisabled }
              >
              { t( 'send-email' ) }
              </LoadingButton>
            </Grid>
            <Grid item xs={12}>
              <Button
                onClick={ onBack }
                fullWidth
                variant='text'
              >{ t( 'back-to-login' ) }</Button>
            </Grid>
          </Grid>
        </form>
      </div>
    </AuthLayout>
  );
}

export default ForgotPassword;
